// ============================================================
// CONFIGURACIÓN CENTRALIZADA DE AXIOS
// ============================================================

import axios from 'axios';
import { baseURLForzada } from './apiURL.js';
import Cookies from 'js-cookie';

// Crear instancia de axios con configuración base
const axiosInstance = axios.create({
  baseURL: baseURLForzada,
  withCredentials: true, // Enviar cookies automáticamente
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de solicitudes
axiosInstance.interceptors.request.use(
  (config) => {
    // Agregar token de las cookies si existe
    const token = Cookies.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuestas
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejo centralizado de errores
    if (error.response) {
      // El servidor respondió con un código de error
      const { status, data } = error.response;
      
      // Silenciar 404 del endpoint de logo (es esperado cuando no hay logo)
      const isLogoEndpoint = error.config?.url?.includes('/logo/usuario/');
      if (status === 404 && isLogoEndpoint) {
        // Retornar un error silencioso que será manejado por la función
        return Promise.reject({
          message: 'Logo no encontrado',
          status: 404,
          data: null,
          silent: true, // Flag para indicar que es un error esperado
        });
      }
      
      // Si el token es inválido o expiró, redirigir al login
      if (status === 401 || status === 403) {
        Cookies.remove('token');
        // Solo redirigir si estamos en el navegador
        if (typeof window !== 'undefined') {
          window.location.href = '/';
        }
      }
      
      // Retornar el error con la información del servidor
      return Promise.reject({
        message: data?.message || data?.error || 'Error en la solicitud',
        status,
        data: data?.errors || data,
      });
    } else if (error.request) {
      // La solicitud se hizo pero no hubo respuesta
      return Promise.reject({
        message: 'No se pudo conectar con el servidor',
        status: 0,
        data: null,
      });
    } else {
      // Algo más causó el error
      return Promise.reject({
        message: error.message || 'Error desconocido',
        status: 0,
        data: null,
      });
    }
  }
);

export default axiosInstance;

